<div class="table-container">
  <div class="table-title">{{showData.name}} [{{showData.showId}}]</div>
  <table mat-table [dataSource]="orderItems">
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> Item </th>
      <td mat-cell *matCellDef="let line"> {{line.description}} </td>
      <td mat-footer-cell *matFooterCellDef> <span class="texy-primary-total"> Total </span> </td>
    </ng-container>

    <!--  -->
    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef> Quantity </th>
      <td mat-cell *matCellDef="let line"> {{line.quantity}} </td>
      <td mat-footer-cell *matFooterCellDef> </td>

    </ng-container>

    <!-- Unit amount -->
    <ng-container matColumnDef="unitAmount">
      <th mat-header-cell *matHeaderCellDef> Unit Amount </th>
      <td mat-cell *matCellDef="let line"> {{line.unitAmount | amount | currency}} </td>
      <td mat-footer-cell *matFooterCellDef> </td>
    </ng-container>

    <!-- Cost Column -->
    <ng-container matColumnDef="cost">
      <th mat-header-cell *matHeaderCellDef> Cost </th>
      <td mat-cell *matCellDef="let line"> {{line.total | amount | currency}} </td>
      <td mat-footer-cell *matFooterCellDef>
        <span class="texy-primary-total"> {{ total | amount | currency}}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
  </table>
</div>